import { render, staticRenderFns } from "./GradeListTable.vue?vue&type=template&id=1dd60c2a&scoped=true"
import script from "./GradeListTable.vue?vue&type=script&lang=js"
export * from "./GradeListTable.vue?vue&type=script&lang=js"
import style0 from "./GradeListTable.vue?vue&type=style&index=0&id=1dd60c2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd60c2a",
  null
  
)

export default component.exports